<template>
  <v-container fluid style="min-width: 320px">
    <v-row align="center" justify="center">
      <v-col cols="12" lg="6" md="8" sm="10">
        <v-card class="elevation-12">
          <v-card-title> Todo List </v-card-title>
          <v-card-subtitle v-if="todosCount > 0">
            {{ countMessage }}
          </v-card-subtitle>
          <v-card-text>
            <NewTodoForm />
            <TodoList
              :searchQuery="searchQuery"
              :todoType="'Newly added'"
              :todos="incompleteTodos"
              :emptyListImage="
                $vuetify.theme.dark
                  ? require('../assets/images/no-data-dark.svg')
                  : require('../assets/images/no-data-light.svg')
              "
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TodoList from '../components/TodoList'
import NewTodoForm from '@/components/NewTodoForm'
export default {
  name: 'Dashboard',
  computed: {
    incompleteTodos() {
      return this.$store.getters.incompleteTodos
    },
    todosCount() {
      return this.$store.getters.incompleteTodos.length
    },
    countMessage() {
      let len = this.todosCount
      return len + (len === 1 ? ' more to go!' : ' todos left')
    },
  },
  props: {
    searchQuery: {
      type: String,
      default: '',
    },
  },
  components: {
    NewTodoForm,
    TodoList,
  },
  data: () => ({
    newTodo: {
      text: '',
      starred: false,
    },
  }),
}
</script>

<style></style>
